export default __webpack_public_path__ + "static/media/img-5.75b34177.png";